import React from "react";

const PngTnc = () => {
  return (
    <div style={{ minHeight: "100vh", background: "#fff" }}>
      <div style={{ maxWidth: 680, margin: "0 auto", padding: "40px 24px" }}>
        <h1 style={{ fontSize: 18, fontWeight: 600, color: "#111", marginBottom: 16 }}>
          Syarat &amp; Ketentuan
        </h1>
        <p style={{ fontSize: 13, lineHeight: 1.7, color: "#444", marginBottom: 12 }}>
          Dengan mengisi formulir ini, Saya mengonfirmasi bahwa saya berusia setidaknya 18 tahun
          memberikan persetujuan kepada PT Procter &amp; Gamble Home Products Indonesia dan
          afiliasinya (&ldquo;P&amp;G&rdquo;) untuk mengumpulkan dan memproses data pribadi Saya
          untuk survey pengecekan faktor risiko neuropati, riset dan publikasi, dan pengembangan
          klaim produk.
        </p>
        <p style={{ fontSize: 13, lineHeight: 1.7, color: "#444", marginBottom: 12 }}>
          Saya juga dengan ini setuju untuk menerima informasi promosi, berita, sampling, survey,
          dan program marketing terpersonalisasi lainnya yang terkait dengan Neurobion serta{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#1a56db", textDecoration: "underline" }}
            href="https://us.pg.com/brands/"
          >
            Brand P&amp;G lainnya
          </a>{" "}
          melalui e-mail, WhatsApp, platform media sosial, dan kanal online lainnya. Saya dapat
          menarik persetujuan saya kapan saja dengan menghubungi P&amp;G di 0800 1402 869.
        </p>
        <p style={{ fontSize: 13, lineHeight: 1.7, color: "#444", marginBottom: 12 }}>
          PT Procter &amp; Gamble Home Products Indonesia adalah pengontrol data dan akan memproses
          data Pribadi Anda sesuai dengan{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#1a56db", textDecoration: "underline" }}
            href="https://privacypolicy.pg.com/id-ID/"
          >
            Kebijakan Privasi Pelanggan
          </a>{" "}
          (pg.com).
        </p>
        <p style={{ fontSize: 13, lineHeight: 1.7, color: "#444", marginBottom: 0 }}>
          Anda setuju bahwa data pribadi Anda akan disimpan oleh P&amp;G hingga tujuan-tujuan
          tersebut tercapai. Anda juga mengetahui dan menyetujui bahwa P&amp;G dapat memberikan
          data tersebut kepada afiliasinya dan penyedia layanan pihak ketiga, baik di dalam maupun
          di luar negeri, untuk pemrosesan lebih lanjut terkait tujuan-tujuan tersebut di atas.
          Untuk informasi lebih lanjut tentang bagaimana P&amp;G memproses data Pribadi Anda dan
          menangani hak subjek data Anda, silakan merujuk ke{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#1a56db", textDecoration: "underline" }}
            href="https://privacypolicy.pg.com/id-ID/"
          >
            Kebijakan Privasi Pelanggan
          </a>{" "}
          (pg.com). Anda mengonfirmasi bahwa Anda telah membaca dan setuju dengan{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#1a56db", textDecoration: "underline" }}
            href="https://termsandconditions.pg.com/id-id/"
          >
            Syarat dan Ketentuan
          </a>{" "}
          (pg.com). Anda mengonfirmasi persetujuan ini dibuat tanpa adanya kekhilafan, kelalaian
          dan/atau paksaan.
        </p>
      </div>
    </div>
  );
};

export default PngTnc;
